import React, { useEffect, useState, useLayoutEffect, createRef } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
// reactstrap components
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";

import "../assets/css/customCheckbox.css";

import {
    FormGroup,
    Label,
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Modal,
    ModalBody,
    Row,
    Col,
    Input
} from "reactstrap";

import TSListPay from "components/Forms/TSListPay.js";
import TSBooking from "components/Forms/TSBooking.js";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

const VaccinePfizer = (props) => {
    const cid = (props.match.params.cid !== undefined) ? props.match.params.cid : null;
    const role = (props.match.params.role !== undefined) ? props.match.params.role : null;

    const [Cid, setCid] = useState("");

    const [confirmCid, setconfirmCid] = useState("");

    const [titleOption, setTitleOption] = useState([]);
  
    const [VaccineType, setVaccineType] = useState("");
    const [TitleName, setTitleName] = useState("");
    const [TitleKey, setTitleKey] = useState("");
    const [FullName, setFullName] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");

    const [BirthDT, setBirthDT] = useState('');
    const [bDay, setbDay] = useState("");
    const [bMonth, setbMonth] = useState("");
    const [bYear, setbYear] = useState("");


 
    const [ErrorMsg2, setErrorMsg2] = useState('');
    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modalConfirm, setModalConfirm] = React.useState(false);

    const [icon, setIcon] = useState("far fa-question-circle");


    var moment = require('moment');
    require('moment/locale/th');

    useEffect(() => {
        document.title = 'ลงทะเบียนวัคซีน Covid-19 ';//และ Booster เข็ม 3 สำหรับ Sinovac 2 เข็ม

        fetch("/api/v1/title"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setTitleOption(result.data) }, (error) => { console.log(error) })
    },[]);


    useLayoutEffect(() => {

    }, []);

    


  



    const handleSubmit = (evt) => {
        evt.preventDefault();
        var errMsg = '';

        var birthdate = moment([bYear, bMonth - 1, bDay]);
/*
        if (!TitleKey)
            errMsg = 'คำนำหน้า / Please select title name';
        else if (!FirstName)
            errMsg = 'ชื่อ / Please enter first name';
        else if (!LastName)
            errMsg = 'นามสกุล / Please enter last name';
 */
        if (!birthdate.isValid())
            errMsg = 'วันเดือนปีเกิดให้ถูกต้อง';

        if (errMsg != '') {
            setErrMsg('กรุณาระบุ' + errMsg);
            setModalError(true);
        }
        else {
            //setModalConfirm(true);
            handleCondition(evt);
        }
    }
    const handleForeign = (evt) => {
        evt.preventDefault();
        window.location.href = '/vaccinequeue/' + Cid;
    }

    const handleCondition = (evt) => {
        evt.preventDefault();
        var birthdate = moment([bYear, bMonth - 1, bDay]);
        var cf = {
            cid: Cid,
            isUpload1: (role == 'admin'),
            isUpload2: (role == 'pz4'),
            birthDT: birthdate.format('YYYY-MM-DD'),
            titleKey: TitleKey,
            titleName: TitleName,
            firstName: FirstName,
            lastName: LastName,
        }
    
        fetch('/api2/pfizer/condition2', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json'},
            body: JSON.stringify(cf)
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    if (result.status == 200)
                    {
                        setVaccineType(result.vaccineType);

                        setErrMsg(result.msg);
                        setModalConfirm(true);
                    }
                    else if (result.status == 201)
                    {
                        window.location.href = '/vaccinequeue/' + Cid;
                    }
                    else {
                        setErrMsg(result.msg);
                        setModalError(true);
                    }
                },
                (error) => {
                    setModalConfirm(false);
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModalError(true);
                }
            );
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        var birthdate = moment([bYear, bMonth - 1, bDay]);
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        var cf = {
            cid: Cid,
            isUpload1: (role == 'admin'),
            isUpload2: (role == 'pz4'),
            birthDT: birthdate.format('YYYY-MM-DD'),
            vaccineType: VaccineType
        }
    
        fetch('/api2/pfizer/register2', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json'},
            body: JSON.stringify(cf)
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {

                    setIcon("far fa-question-circle");
                    setModalConfirm(false);

                    if (result.status == 200) {
                        window.location.href = '/vaccinequeue/' + Cid;
                    }
                    else {
                        setModalConfirm(false);
                        setIcon("far fa-question-circle");
                        setErrMsg(result.msg);
                        setModalError(true);
                    }
                },
                (error) => {
                    setModalConfirm(false);
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModalError(true);
                }
            );
    }



    const handleCID = (val) => {
        setCid(val)
        let e = val;

        if (e.length === 13) {
            let sum = 0;
            for (let i = 0; i < 12; i++) {
                sum += parseFloat(e.charAt(i)) * (13 - i);
            }

            if ((11 - sum % 11) % 10 !== parseFloat(e.charAt(12))) {

                setCid('')
                setErrMsg('เลขบัตรประชาชนของคุณไม่ถูกต้องตามหลักทะเบียนราษฎร์');
                setModalError(true);
                //$('#inputid').addClass('has-error');
                //return false;

            } else {

                //$('#inputid').removeClass('has-error');
                //$('#inputid').addClass('has-success');
                //return true;

            }
        }
    }


    return (
        <>
            <Container>
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '250px', color: 'white', backgroundColor: '#056839', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>
                        บริการวัคซีน Covid-19 {/*<br/> และ Booster เข็ม 3 สำหรับ Sinovac 2 เข็ม*/}
                        
                        {/*}
                        {FullName} <br />
                        {(CertId != "") ?
                            <a href={"https://co19cert.moph.go.th/moph-immu/#/vaccine/certificate?cid=" + CertId} target="_blank">
                                <img src={"https://co19cert.moph.go.th/moph-backend/api/immunization-stat/qr/" + CertId} width="145" /> <br />
                                <div style={{ fontSize: '0.9rem', color: 'white' }}> QRCode ใบรับรองแบบย่อ จากกระทรวงสาธารณสุข</div>
                            </a>
                            :
                            <></>
                        }
                        */}
                    </Col>
   
                </Row>
                <Row style={{ padding: '10px', margin: '-150px 0 0 0' }}>
                    <Col>

               

                 
                        <Row style={{ marginBottom: '10px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', color: 'green', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> ลงทะเบียนรับวัคซีน </Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>

                                        <Row style={{ textAlign: 'left', padding: '5px', fontSize: '1.2rem' }}>
                                    <Col md="12" >
                                        <TSText type="tel" placeholder="เลขที่บัตรประจำตัวประชาชน" background={'white'} value={Cid} maxLength="13" onChange={e => handleCID(e.target.value)} icon="far fa-id-card" />
                                    </Col>
                                    <Col xs="12" md="4" style={{ fontSize: '0.8em' }}>
                                        <TSSelect placeholder="วันเกิด/Birth Day" fixData="day" onChange={e => setbDay(e)} value={bDay} />
                                    </Col>
                                    <Col xs="12" md="4" style={{ fontSize: '0.8em' }}>
                                        <TSSelect placeholder="เดือนเกิด/Birth Month" fixData="month" onChange={e => setbMonth(e)} value={bMonth} />
                                    </Col>
                                    <Col xs="12" md="4" style={{ fontSize: '0.8em' }}>

                                        <TSSelect placeholder="ปีเกิด/Birth Year" fixData="year" onChange={e => setbYear(e)} value={bYear} />
                                    </Col>
{/*
                                            <Col md="4" style={{ fontSize: '0.8em' }}>
                                                <TSSelect placeholder="คำนำหน้า/Title Name" options={titleOption}  onChange={e => { setTitleKey(e); setTitleName((!e) ? '' : titleOption.find(t => t.value == e).label); }} value={TitleKey} require marginBottom={'8px'} />
                                            </Col>
                                            <Col md="4" >
                                                <TSText placeholder="ชื่อ/First Name" value={FirstName} background={'white'} onChange={e => setFirstName(e.target.value)} icon="fas fa-user-lock" />
                                            </Col>
                                            <Col md="4" >
                                                <TSText placeholder="สกุล/Last Name" value={LastName} background={'white'} onChange={e => setLastName(e.target.value)} icon="fas fa-user-lock" />
                                            </Col>
 */}         

                                            
                                            
                                        </Row>

                                        <Row>
                                            <Col className="text-center ml-auto mr-auto" md="86">
                                                <div className="send-button">
                                                     <Button
                                                                block
                                                                className="btn-round"
                                                                color="info"
                                                                href="#pablo"
                                                                onClick={handleSubmit}
                                                                size="lg"
                                                            >
                                                        ลงทะเบียน/เช็คคิว
                                                    </Button> 
                                            {/*
                                                    <Button
                                                        block
                                                        className="btn-round"
                                                        color="warning"
                                                        href="#pablo"
                                                        onClick={handleForeign}
                                                        size="lg"
                                                    >
                                                        Check Queue  
                                                    </Button> 
                                                    */}
                                                    {/* Confirm */}
                                                    <Modal
                                                        modalClassName="modal-mini modal-info"
                                                        toggle={() => setModalConfirm(false)}
                                                        isOpen={modalConfirm}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>
                                                            <p> {errMsg} </p>
                                                            <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการลงทะเบียน" : "กำลังตรวจสอบข้อมูล"}</p>
                                                        </ModalBody>
                                                        <div className="modal-footer">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={() => setModalConfirm(false)}
                                                            >
                                                                ยกเลิก
                                      </Button>

                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={handleConfirm}
                                                                disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                            //onClick={() => setModal2(false)}
                                                            >
                                                                กรอกข้อมูลเพิ่ม
                                      </Button>
                                                        </div>
                                                    </Modal>


                                                    {/* Error */}
                                                    <Modal
                                                        modalClassName="modal-mini modal-danger"
                                                        toggle={() => setModalError(false)}
                                                        isOpen={modalError}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>
                                                            <p>ไม่สามารถลงทะเบียนได้</p>
                                                            <p> {errMsg} </p>
                                                        </ModalBody>
                                                        <div className="modal-footer justify-content-center">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="neutral"
                                                                type="button"
                                                                onClick={() => setModalError(false)}
                                                            >
                                                                ตกลง
                                      </Button>
                                                        </div>
                                                    </Modal>
                                                </div>
                                            </Col>
                                        </Row>

                                    </Col>
                        </Row>

                        <Row style={{ marginBottom: '10px' }}>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: '10px', fontSize: '1.5em', height: '50px', backgroundColor: '#f0dc64', textAlign: 'center', borderRadius: '10px 10px 0 0' }}> รายละเอียด</Col>
                            <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{ padding: 0, fontSize: '1.2em', paddingBottom: '30px', backgroundColor: '#eee', textAlign: 'center', borderRadius: '0 0 10% 10%' }}>

                                <Row style={{ textAlign: 'left', padding: '5px' }}>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12"></Col>
                                </Row>
                                <Row style={{ textAlign: 'left', padding: '5px', fontSize: '1rem' }}>

                                    <Col xs="12" sm="12" md="12" lg="12" xl="12"></Col>
                                    <Col xs="12" sm="12" md="12" lg="12" xl="12"></Col>
                                </Row>
                            </Col>
                        </Row>



                    </Col>
                </Row>

           </Container>
        </>
    );
}

export default VaccinePfizer;
